<template>
	<PlanComparisonPaywall
		v-if="isVisible"
		headline="Keep writing strong bullets without the struggle"
		:subcopy="subcopy"
		:reopen="reopen"
		@close="dismiss"
		@stay-free="dismiss"
		@upgrade="dismiss"
	/>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import PlanComparisonPaywall from './plan-comparison-paywall.vue';
import { useFeatureUsageStore } from '../store/feature-usage.store';

const FEATURE = 'bullet_generation_tool';
const DEFAULT_FREE_LIMIT = 5;

/**
 * EN-811: the paywall shown when a free user tries to generate bullet points with no
 * credits left. Driven by the same `setShowLimitExceed` call the legacy premium-plans
 * modal used to answer — which is why that modal now excludes this feature.
 */
const featureUsageStore = useFeatureUsageStore();
const { showLimitExceed, currentFeature, userFeatureUsage } = storeToRefs(featureUsageStore);

const isVisible = computed(() => showLimitExceed.value && currentFeature.value === FEATURE);

const freeLimit = computed(
	() => userFeatureUsage.value?.find((feature) => feature.name === FEATURE)?.free_limit ?? DEFAULT_FREE_LIMIT,
);

const subcopy = computed(
	() => `You've used your ${freeLimit.value} free generations. Every role is different, and your bullets should be too. Upgrade for unlimited generations.`,
);

// Every action here just closes the paywall. On upgrade the global purchase modal has
// already been opened by the shared component, so hiding this one hands over to it.
const dismiss = () => featureUsageStore.hideLimitExceed();

// Back from checkout. Not setShowLimitExceed(): that would log another paywall view.
const reopen = () => {
	showLimitExceed.value = true;
};
</script>
